{
  "status": {
    "draft": "Draft",
    "published": "Published",
    "closed": "Closed",
    "archived": "Archived"
  },
  "questionTypes": {
    "text": "Short text",
    "textarea": "Long text",
    "number": "Number",
    "currency": "Currency (R$)",
    "select": "Single choice",
    "multiselect": "Multiple choice",
    "checkbox": "Checkbox",
    "scale": "Scale",
    "nps": "NPS (0-10)",
    "rating": "Rating (stars)"
  },
  "triggerTypes": {
    "general": "General — shows up when entering the platform",
    "courseCompleted": "After completing a specific course",
    "moduleCompleted": "After completing a specific module",
    "lessonCompleted": "After completing a specific lesson",
    "daysAfterSignup": "X days after sign-up",
    "daysAfterEnrollment": "X days after enrollment",
    "signupPeriod": "Sign-up period (start and end date)"
  },
  "triggerConfig": {
    "general": {
      "short": "Shows up for every student as soon as they enter the platform.",
      "example": "E.g. General satisfaction survey to collect broad feedback."
    },
    "courseCompleted": {
      "short": "Fires when the student completes 100% of the lessons in a specific course.",
      "example": "E.g. Ask for NPS when the student finishes the full \"JavaScript from Scratch\" course."
    },
    "lessonCompleted": {
      "short": "Fires when the student marks a specific lesson as completed.",
      "example": "E.g. \"How would you rate this lesson?\" — shows up at the end of the welcome lesson."
    },
    "moduleCompleted": {
      "short": "Fires when the student completes every lesson in a specific module.",
      "example": "E.g. Ask for an NPS score after the student finishes the JavaScript module."
    },
    "daysAfterSignup": {
      "short": "Fires X days after the student created their account.",
      "example": "E.g. \"How is your experience so far?\" 7 days after sign-up."
    },
    "daysAfterEnrollment": {
      "short": "Fires X days after the student enrolls in a specific course.",
      "example": "E.g. Ask for a review 30 days after buying the premium course."
    },
    "signupPeriod": {
      "short": "Shows up only for students who signed up within a specific period.",
      "example": "E.g. Survey for the January cohort: sign-ups between 01/01 and 01/31."
    }
  },
  "list": {
    "title": "Surveys",
    "subtitle": "Create and manage customizable surveys for your students",
    "newSurvey": "New Survey",
    "newSurveyTitle": "New Survey",
    "stats": {
      "total": "Total",
      "published": "Published",
      "responses": "Responses",
      "questions": "Questions"
    },
    "tabs": {
      "all": "All",
      "draft": "Draft",
      "published": "Published",
      "closed": "Closed"
    },
    "empty": {
      "title": "No surveys found",
      "description": "Create your first survey to collect student feedback",
      "create": "Create survey"
    },
    "actions": {
      "edit": "Edit",
      "duplicate": "Duplicate",
      "publish": "Publish",
      "close": "Close",
      "delete": "Delete"
    },
    "card": {
      "anonymous": "Anonymous",
      "questions": "Questions",
      "responses": "Responses",
      "triggers": "Triggers",
      "createdAt": "Created on {{date}}",
      "open": "Open →"
    },
    "deleteDialog": {
      "title": "Delete survey",
      "description": "Are you sure you want to delete <bold>{{title}}</bold>? All responses will be lost.",
      "cancel": "Cancel",
      "confirm": "Delete"
    }
  },
  "edit": {
    "common": {
      "cancel": "Cancel",
      "save": "Save",
      "add": "Add"
    },
    "header": {
      "back": "Back",
      "editTitleHint": "Click to edit title and description",
      "responsesCount_one": "{{count}} response",
      "responsesCount_zero": "{{count}} responses",
      "responsesCount_other": "{{count}} responses",
      "questionsCount_one": "{{count}} question",
      "questionsCount_zero": "{{count}} questions",
      "questionsCount_other": "{{count}} questions",
      "edit": "Edit",
      "previewAsStudent": "Preview as student",
      "publish": "Publish",
      "close": "Close"
    },
    "tabs": {
      "questions": "Questions ({{count}})",
      "triggers": "Triggers ({{count}})",
      "results": "Results"
    },
    "questions": {
      "add": "Add Question",
      "empty": "No questions yet. Add the first one!",
      "section": "Section: {{section}}",
      "fullPreview": "Full preview — how the student will see it",
      "sampleOptionA": "Option A",
      "sampleOptionB": "Option B"
    },
    "triggers": {
      "infoTitle": "What are triggers?",
      "infoDescription": "Triggers define <bold>when your survey shows up for the student</bold>. Without a trigger, the survey stays published but is shown to no one. With a trigger (e.g. \"after completing lesson X\"), it shows up automatically at the right moment, generating relevant responses.",
      "infoMultiple": "You can add <bold>more than one trigger</bold> — the survey shows up as soon as any of them fires.",
      "configured": "Configured triggers ({{count}})",
      "add": "Add trigger",
      "emptyTitle": "No triggers configured",
      "emptyDescription": "Without triggers, your survey is published but will not show up for students. Add the first trigger below.",
      "addFirst": "Add first trigger",
      "removed": "Trigger removed",
      "days_one": "{{count}} day",
      "days_zero": "{{count}} days",
      "days_other": "{{count}} days"
    },
    "results": {
      "emptyTitle": "No responses yet",
      "emptyDescription": "Once students respond, metrics, respondents and statistics will show up here.",
      "perQuestion": "Per-question analysis",
      "answersCount_one": "{{count}} response",
      "answersCount_zero": "{{count}} responses",
      "answersCount_other": "{{count}} responses",
      "promoters": "Promoters",
      "neutrals": "Passives",
      "detractors": "Detractors",
      "average": "average"
    },
    "deleteQuestion": {
      "title": "Delete question",
      "description": "Delete \"{{label}}\"?",
      "confirm": "Delete",
      "success": "Question deleted"
    },
    "questionDialog": {
      "labelRequired": "Question is required",
      "updated": "Question updated",
      "added": "Question added",
      "saveError": "Error saving question",
      "editTitle": "Edit Question",
      "newTitle": "New Question",
      "label": "Question *",
      "labelPlaceholder": "E.g. What did you think of the course?",
      "type": "Type",
      "section": "Section (optional)",
      "sectionPlaceholder": "E.g. About the course",
      "description": "Description (optional)",
      "descriptionPlaceholder": "Help or context for the student",
      "placeholder": "Placeholder",
      "placeholderPlaceholder": "Text inside the field",
      "options": "Options (comma-separated)",
      "optionsPlaceholder": "Option A, Option B, Option C",
      "min": "Minimum",
      "max": "Maximum",
      "required": "Required"
    },
    "triggerDialog": {
      "added": "Trigger added",
      "addError": "Error adding trigger",
      "title": "New trigger",
      "description": "Choose when this survey should show up for the student.",
      "whenLabel": "When should this survey show up?",
      "selectCourse": "Select the course",
      "change": "Change",
      "modulesCount_one": "{{count}} module",
      "modulesCount_zero": "{{count}} modules",
      "modulesCount_other": "{{count}} modules",
      "searchCourse": "Search course...",
      "noCourses": "No courses found",
      "selectModule": "Select the module",
      "lessonsCount_one": "{{count}} lesson",
      "lessonsCount_zero": "{{count}} lessons",
      "lessonsCount_other": "{{count}} lessons",
      "noModules": "This course has no modules",
      "selectLesson": "Select the lesson",
      "noLessons": "This module has no lessons",
      "daysLabel": "After how many days?",
      "daysHint": "The survey will be shown once that many days have passed.",
      "signupFrom": "Sign-ups from",
      "signupUntil": "Sign-ups until",
      "periodHint": "Only students whose sign-up date falls within this period will receive the survey. You can fill in just one of the dates.",
      "submit": "Add trigger"
    },
    "settings": {
      "titleRequired": "Title is required",
      "saveError": "Error saving",
      "title": "Survey settings",
      "description": "Edit the title, description and display options.",
      "titleLabel": "Title *",
      "titlePlaceholder": "E.g. Satisfaction survey — JavaScript Course",
      "descriptionLabel": "Description",
      "descriptionPlaceholder": "Explain the purpose of the survey to the student",
      "descriptionHint": "Shows up right below the title on the intro screen.",
      "anonymous": "Anonymous response",
      "anonymousHint": "Does not store which student submitted the response.",
      "allowMultiple": "Multiple responses",
      "allowMultipleHint": "Lets the same student respond more than once.",
      "xpReward": "XP for responding",
      "xpRewardHint": "Gamification points the student earns for completing the survey.",
      "window": "Display window (optional)",
      "start": "Start",
      "end": "End",
      "windowPermanent": "<highlight>Permanent survey:</highlight> with no start or end, it stays available while it is published.",
      "windowUntil": "Available <bold>now until</bold> {{end}}.",
      "windowFrom": "Starts on <bold>{{start}}</bold> and stays permanent after that.",
      "windowRange": "Visible from <bold>{{start}}</bold> to <bold>{{end}}</bold>.",
      "saveChanges": "Save changes"
    },
    "preview": {
      "badge": "Preview · Student view",
      "restart": "Restart",
      "completed": "Completed",
      "step": "Step {{current}} of {{total}}",
      "yourOpinionMatters": "Your opinion matters",
      "defaultDescription": "Answer a few quick questions and help us improve your experience.",
      "questionsCount_one": "{{count}} question",
      "questionsCount_zero": "{{count}} questions",
      "questionsCount_other": "{{count}} questions",
      "start": "Start now",
      "previous": "Previous",
      "submit": "Submit response",
      "next": "Next",
      "thanks": "Thank you!",
      "success": "Your response was submitted successfully",
      "xpEarned": "+{{xp}} XP earned",
      "selectPlaceholder": "Select",
      "npsNotLikely": "Not at all likely",
      "npsVeryLikely": "Very likely"
    },
    "metrics": {
      "total": "Total",
      "totalHint": "Responses received",
      "anonymousResponses": "Anonymous responses",
      "unique": "Unique",
      "anonymousHint": "Not identified",
      "uniqueHint": "Distinct students",
      "completion": "Completion",
      "completionHint": "Completed responses",
      "period": "Period",
      "periodHint": "First → last"
    },
    "respondents": {
      "title": "Respondents ({{count}})",
      "anonymous": "Anonymous response",
      "answersAt": "Answers · {{date}}",
      "question": "Question",
      "noAnswer": "No answer"
    }
  }
}
